// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "static/js/" + chunkId + "-legacy." + {"153":"e282ec46","260":"2ffc633c","668":"44482a41","762":"8ef960b7"}[chunkId] + ".js"; };